/**
 * Initializes modules, which are used across all pages in app.
 */
import initLogoMorph from '../organizedByType/initializers/logoMorphInitializer'
import initGlobalPromiseRejectionHandler from '../organizedByType/initializers/initGlobalRejectionHandler'

initGlobalPromiseRejectionHandler()
initLogoMorph()



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/application/bootstrap_common.js